import React, { Component } from 'react';
import { Input } from 'antd';

class TypeNumeric extends Component{
	constructor(props) {
		super(props);
		this.state = {
			value: '',
		};
	}
	
	validate = (value) => {
		const reg = /^-?(0|[1-9][0-9]*)?$/;
		return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-');
	};
	
	onChange = (e) => {
		const { value } = e.target;
		if (this.validate(value)) {
			this.props.onChange(value);
			this.setState({ value });
		}
	};
	onBlur = (e) => {
		const { value } = e.target;
		if (value.charAt(value.length - 1) === '.' || value === '-') {
			this.onChange(value.slice(0, -1));
		}
	};
	
	render() {
		const { title, className } = this.props;
		return (
			<div className={className}>
				<Input
					size='default'
					onChange={this.onChange}
					onBlur={this.onBlur}
					value={this.state.value}
					placeholder={title}
					maxLength="25"
				/>
			</div>
		);
	}
};

export default TypeNumeric;


// WEBPACK FOOTER //
// ./src/components/AnswerTypeNumeric/TypeNumeric.js